import { makeObservable, observable, runInAction } from 'mobx';
import defaultImage from '../../view/pages/ShopItem/images/default.png';

class ShopItem {
    amount = 0;
    price = 0;
    isActive = false;
    soonActive = false;

    constructor(store, data) {
        this.id = data.id;
        this.store = store;
        this.data = data;
        this.name = data.name;
        this.isDigital = data.isDigital;
        this.images = this.isDigital ? null : data.files.map( file => `/media/${ file.file }` );
        this.photo = data.photoResized ? data.photoResized : data.photo ? data.photo : defaultImage;
        runInAction(() => {
            this.price = this.data.price;
            this.amount = this.data.amount;
            this.isActive = this.data.isActive;
            this.soonActive = this.data.soonActive;
        })
        makeObservable(this, {
            price: observable,
            amount: observable,
            isActive: observable,
            soonActive: observable
        })
    }

    updateFromJson(json) {
        runInAction(() => {
            this.price = json.price;
            this.amount = json.amount;
            this.isActive = json.isActive;
            this.soonActive = json.soonActive;
        })
        this.data = { ...this.data, ...json };
    }

    get isAudiobook() {
        return this.name.toLowerCase().includes('аудиокниг');
    }

    get isMaterials() {
        if (this.name.toLowerCase() === '«психолог моего психолога» - проект супервизий вероники сидоровой') return true;
        return this.name.toLowerCase().includes('запись вебинара') || this.name.toLowerCase().includes('материалы');
    }

    get isWebinar() {
        return this.name.toLowerCase().includes('вебинар');
    }

    get isCourse() {
        return this.name.toLowerCase().includes('курс');
    }

    static isSupervision(name) {
        const supervisions = [
            '«Я - плохая мать»',
            '«Я не знаю, каково мое предназначение»',
            '«У меня нет подруг»',
            '«Я хочу вернуть бывшие отношения»',
            '«Моя свекровь меня не любит»',
            '«Я хочу отношения только с состоятельным мужчиной»',
            '«У меня депрессия»',
            '«Я хочу вести социальные сети, но мне мешает страх»'
        ]
        return supervisions.some((supervision) => new RegExp(supervision).test(name));
    }

    static isFamilySystem(name) {
        const familySystem = [
            'Видео-лекция: «Свекровь и невестка»',
            'Видео-лекция: «Дети мужа от первого брака»',
            'Видео-лекция: «Роль няни в семейной системе»',
            'Видео-лекция: «Отец взрослой дочери»',
            'Видео-лекция: «С кем в семье нужно дружить\\?»',
            'Семейная системная терапия: цикл бесед — «Разрушить нельзя строить»'
        ]
        return familySystem.some((course) => new RegExp(course).test(name));
    }

    get isSupervision() {
        return ShopItem.isSupervision(this.name);
    }

    get buttonText() {
        if (!this.isDigital) {
            console.error('method must be applied to digital item');
            return 'Купить';
        }

        const courseActive = this.isActive && this.amount !== 0;

        if (!courseActive && this.soonActive) {
            return 'Скоро в продаже';
        }

        if (!this.soonActive) {
            if (this.isAudiobook) {
                return courseActive ? 'Купить аудиокнигу' : 'Аудиокнига продана';
            }

            if (this.isMaterials || this.isSupervision) {
                return courseActive ? 'Купить материалы' : 'Материалы проданы';
            }

            if (this.isWebinar) {
                return courseActive ? 'Присоединиться' : 'Вебинар продан';
            }

            if (this.isCourse) {
                return courseActive ? 'Присоединиться к курсу' : 'Курс продан';
            }
        }

        return courseActive ? 'Купить' : 'Продано';
    }

    get tags() {
        return this.data.tags.map(tag => tag.title);
    }

}

export default ShopItem
